///Import react section
import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import autoBind from 'auto-bind';
import { withRouter } from "react-router-dom";
import withauthenticatedLayout from '../layouts/withauthenticatedLayout';
import {loadQuoteFromBackEnd} from '../../store/quotes/QuotesActions';
import { connect } from 'react-redux';
import {cancelWorflowFromBackend} from '../../store/workflows/workflowActions';
import CancelWorkflow from '../common/CancelWorkflow';

class CancelContainer extends Component {
  constructor (props) {
    super(props);
    autoBind(this);
    this.state = {

    }
  }

    /**
    * componentDidMount
    */
   componentDidMount() {
    let quoteToken = this.props.match.params.token;
    this.props.loadQuote(quoteToken);
}

      /**
     * Cancel a quote from back end
     */
    onCancelWorkflowsDocument(cancelComment, razonForCancel){
      let token =this.props.match.params.token;
      this.props.cancelWorflowFromBackend(token, cancelComment, razonForCancel)
      .then(() =>{
        this.props.history.push(`/quotes/${this.props.quote.token}`)
      }).catch(() =>{
          this.setState({
              showToaster: true,
              toasterMessage: <Translate id="common.errorToSave" />,
              toasterVariant: "error",
          })
      })
  }

  render () {
    return (
      <CancelWorkflow
        {...this.props}
          workflow= {this.props.quote}
          onCancelWorkflowsDocument={this.onCancelWorkflowsDocument}
          isSaving={this.props.isCancel}
          link = {'quotes'}
      />
    )
  }
}

/**
 *  Defines the properties injecteded from the store to view container
 *
 * @param {*} state
 * @returns
 */
function mapStateToProps(state) {
    let quote = state.quotes.get("quote");
   return {
      isCancel: state.workflow.get('isCancel'),
      quote: quote ? quote.toJS() : null,
  }
}

/**
 * Defines the actions injectes to the component
 *
 * @param {*} state
 * @returns
 */
const mapDispatchToProps = dispatch => {
  return {
    loadQuote: (token) => {
        return dispatch(loadQuoteFromBackEnd(token));
    },
    cancelWorflowFromBackend: (token, cancelComment, razonForCancel) => {
        return dispatch(cancelWorflowFromBackend(token, cancelComment, razonForCancel));
    },
    
  }
}

export default withauthenticatedLayout((withRouter) (connect(mapStateToProps, mapDispatchToProps)(CancelContainer)));